import { useEffect, useState } from 'react';
import { api } from '../../api';
import TileCard from '../components/TileCard';

/**
 * Requests buckets tile — monthly count per bucket type (no_charge /
 * refund / discount). Pulls /api/requests/stats, which is already
 * visibility-scoped on the server (a Sales rep sees their own
 * submissions; GMs see their reports' submissions).
 *
 * Props:
 *   title     (optional) — card title override
 *   buckets   (optional) — array of bucket keys to display. Defaults to
 *                          ['no_charge', 'refund', 'discount'].
 */
const LABELS = {
  no_charge: 'No Charges',
  refund:    'Refunds',
  discount:  'Discounts',
  take_back: 'Take Backs',
  bad_tow:   'Bad Tows',
};

export default function RequestsBucketsTile({
  title = 'This Month',
  buckets = ['no_charge', 'refund', 'discount'],
}) {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    let cancelled = false;
    api.getRequestStats()
      .then(d => { if (!cancelled) setState({ loading: false, error: null, data: d }); })
      .catch(err => { if (!cancelled) setState({ loading: false, error: err?.message || 'failed', data: null }); });
    return () => { cancelled = true; };
  }, []);

  const counts = state.data?.monthly_counts || {};

  return (
    <TileCard
      title={title}
      loading={state.loading}
      error={state.error}
      actionHref="/sales/requests"
      actionLabel="Requests →"
    >
      <div className="dash-stat-row" style={{ gridTemplateColumns: `repeat(${buckets.length}, 1fr)` }}>
        {buckets.map(key => (
          <div key={key} className="dash-stat-chip">
            <div className="dash-stat-chip-value">{counts[key] ?? 0}</div>
            <div className="dash-stat-chip-label">{LABELS[key] || key}</div>
          </div>
        ))}
      </div>
      <div className="dash-card-empty" style={{ flex: 'initial', justifyContent: 'flex-start', padding: '8px 2px' }}>
        {state.data?.scope_kind === 'own' ? 'Your submissions this month' :
         state.data?.scope_kind === 'reports' ? "Your team's submissions" : 'Company-wide this month'}
      </div>
    </TileCard>
  );
}
